import { LoginSection } from 'LoginUI';
import {
  SelectWalletBox,
 } from 'KeysAndSigningUI';
import { ForDevelopment } from './dev/developmentUI';
import { useGlobalStateSelector, words } from './globalState';
import {
  handleClickBuildDeck,
  handleClickDuelRanking,
  handleClickChargePoint,
  handleClickCardRegistration,
  handleClickPlayerStats,
  handleClickSetting,
  handleClickDuelHistory,
  handleClickCardList,
  handleClickPurchaseItem,
  handleClickItemOrderHistory,
 } from './monadomCore';
import logoTitle from './title.png';
import imageWhatIsKnightsOfMonadom from './whatIsKnightsOfMonadom.png';
import imageMonashellBanner from './monashellBanner.png';
import sctHtml from './sct.static.html';

// TOP
function Top() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  // let loginStyle;

  // if (Object.values(state.session).some( session => session.expirationOfSession > Date.now() )) {
  //   loginStyle = 'backgroundColorMonacottoPale';
  // }
  // else {
  //   loginStyle = 'backgroundColorMonacottoAlmostWhite';
  // }

  // // TAC文言

  // let tacWord;

  // if (state.configure.acceptedVersionOfTheTermsAndConditions === state.config.clientParameters.versionOfTheTermsAndConditions &&
  //     state.configure.acceptedVersionOfPrivacyPolicy === state.config.clientParameters.versionOfPrivacyPolicy) {
  //   tacWord = words.theTermsAndConditionsAndPrivacypolicyHaveBeenAccepted[state.language];
  // }
  // else {
  //   tacWord = words.termsAndConditionsAndPrivacypolicy[state.language];
  // }

  // ユーザー登録ボタン

  const registrationButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
    onClick={ () => {
      const popup = { type: 'userRegistrationPopup' };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
    }}
  >
    { words.userRegistration[state.language] }
  </button>;


  return (
    <div className=''>
      {/* PC */}
      <div className="visibleMiddleOrMore mainKOM">
        <div className="flexColumn alignItemsCenter relative">
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
          </div>
          <div className="flexColumn alignItemsCenter margin1">
            <img className='width60' src={logoTitle} alt='title' />
          </div>
          <div className="flexRow justifyContentCenter marginBottom1">
            <button className='backgroundColorTransparent borderNone cursor '
              onClick={ () => navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/aboutknightsofmonadom' : '/aboutknightsofmonadom') }
            >
              <img className='width35' src={imageWhatIsKnightsOfMonadom} alt='what is knights of monadom' />
            </button>
            <button className='backgroundColorTransparent borderNone cursor '
              onClick={ () => window.open('https://' + process.env.REACT_APP_MONASHELL_MAIN_URL) }
            >
              <img className='width35' src={imageMonashellBanner} alt='monashell' />
            </button>
          </div>
          <div className="width60 ">
            <NotificationPersistent />
          </div>
          <div className="flexRow justifyContentCenter marginBottom1 width60 ">
            <SelectWalletBox keypoolButtonVisible={false} />
          </div>
          <div className="flexRow justifyContentCenter ">
            <div className="flexColumn alignItemsFlexStart">
              <LoginSection />
              <div className="marginTop1">
                { registrationButton }
              </div>
            </div>
            <div className="flexColumn alignItemsFlexStart">
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
                onClick={ () => {
                  window.open('https://note.com/jungjung/n/n5c4a02ad79cc');
                }}
              >
                { words.howToPlay[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
                onClick={ () => {
                  const popup = { type: 'challengeDuelPopup' };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                }}
              >
                { words.playDuel[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickBuildDeck(state, dispatch, navigate) }>
                { words.decks[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickDuelHistory(state, dispatch, navigate) }>
                { words.duelHistory[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickDuelRanking(state, dispatch, navigate) }>
                { words.duelRanking[state.language] }
              </button>
            </div>
            <div className="flexColumn alignItemsFlexStart">
            </div>
            <div className="flexColumn alignItemsFlexStart">
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickPlayerStats(state, dispatch, navigate) }>
                { words.playerStats[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickCardList(state, dispatch, navigate) }>
                { words.cardList[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
                onClick={ () => {
                  const body =
                  <div className='flexRow justifyContentCenter alignItemsCenter ' >
                    <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                      onClick={ () => {
                        if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
                          window.open('https://monacotto.monatoka.com/redirect?mainaddress=M8uspWdxFbDGgV84PE2tUUGHJPUEXA39Uu');
                        }
                        else {
                          window.open('https://dev.monacotto.monatoka.com/build/redirect?mainaddress=MJehBJHrp8W46XFNpr2QZiy9vRqMVKNpPq');
                        }

                        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                      }}
                    >
                      <div>
                        { words.purchaseCards[state.language] }
                      </div>
                      <div>
                        { words.purchaseInMonacoin[state.language] }
                      </div>
                    </button>
                    <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                      onClick={ () => {
                        handleClickPurchaseItem(state, dispatch, navigate);
                        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                      }}
                    >
                      <div>
                        { words.purchaseCardsAndMonatokaPoints[state.language] }
                      </div>
                      <div>
                        { words.purchaseInJpy[state.language] }
                      </div>
                    </button>
                    <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                      onClick={ () => {
                        handleClickItemOrderHistory(state, dispatch, navigate);
                        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                      }}
                    >
                      <div>
                        { words.purchaseHistoryOfCardsAndMonatokaPoints[state.language] }
                      </div>
                      <div>
                        { words.purchaseInJpy[state.language] }
                      </div>
                    </button>
                    <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                      onClick={ () => {
                        window.open('https://monatoka.booth.pm/');

                        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                      }}
                    >
                      <div>
                        { words.monadomKeyCard[state.language] }
                      </div>
                    </button>
                    <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                      onClick={ () => {
                        handleClickChargePoint(state, dispatch, navigate);
                        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                      }}
                    >
                      { words.monatokaPoint[state.language] }
                    </button>
                  </div>;

                  const popup = { type: 'generalItems', body: body };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
                }}
              >
                { words.purchaseCardsAndMonatokaPoints[state.language] }
              </button>
              {
                process.env.REACT_APP_ENVIRONMENT === 'dev' ? 
                <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
                  onClick={ () => {
                    if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
                      window.open('https://monachen.monatoka.com/');
                    }
                    else {
                      window.open('https://dev.monachen.monatoka.com/build/index.html');
                    }
                  }}
                >
                  { words.iWantMonacoin[state.language] }
                </button>
                : null
              }
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickCardRegistration(state, dispatch, navigate) }>
                { words.cardRegistration[state.language] }
              </button>
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickSetting(state, dispatch, navigate) }>
                { words.setting[state.language] }
              </button>
            </div>
          </div>
          {/* development */}
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
        {/* footer */}
        <Footer />
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess mainKOM ">
        <div className="flexColumn alignItemsCenter relative widthMax">
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
          </div>
          <div className="flexColumn alignItemsCenter widthMax">
            <img className='widthMax' src={logoTitle} alt='title' />
          </div>
          <div className="flexColumn alignItemsCenter marginTopBottom0p5">
            <button className='backgroundColorTransparent borderNone '
              onClick={ () => navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/aboutknightsofmonadom' : '/aboutknightsofmonadom') }
            >
              <img className='width60vw' src={imageWhatIsKnightsOfMonadom} alt='what is knights of monadom' />
            </button>
            <button className='backgroundColorTransparent borderNone cursor '
              onClick={ () => window.open('https://' + process.env.REACT_APP_MONASHELL_MAIN_URL) }
            >
              <img className='width75vw' src={imageMonashellBanner} alt='monashell' />
            </button>
          </div>
          <div className='flexColumn widthMax padding0p5 marginTopBottom0p5 '>
            <SelectWalletBox keypoolButtonVisible={false} />
          </div>
          <LoginSection />
          <NotificationPersistent />
          <div className="marginTop1">
            { registrationButton }
          </div>
          <div className="flexColumn alignItemsFlexStart">
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ () => {
                window.open('https://note.com/jungjung/n/n5c4a02ad79cc');
              }}
            >
              { words.howToPlay[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ () => {
                const popup = { type: 'challengeDuelPopup' };
                dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
              }}
            >
              { words.playDuel[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickBuildDeck(state, dispatch, navigate) }>
              { words.decks[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickDuelHistory(state, dispatch, navigate) }>
              { words.duelHistory[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickDuelRanking(state, dispatch, navigate) }>
              { words.duelRanking[state.language] }
            </button>
          </div>
          <div className="flexColumn alignItemsFlexStart">
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickPlayerStats(state, dispatch, navigate) }>
              { words.playerStats[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickCardList(state, dispatch, navigate) }>
              { words.cardList[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter '
              onClick={ () => {
                const body =
                <div className='flexColumn justifyContentCenter alignItemsCenter ' >
                  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                    onClick={ () => {
                      if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
                        window.open('https://monacotto.monatoka.com/redirect?mainaddress=M8uspWdxFbDGgV84PE2tUUGHJPUEXA39Uu');
                      }
                      else {
                        window.open('https://dev.monacotto.monatoka.com/build/redirect?mainaddress=MJehBJHrp8W46XFNpr2QZiy9vRqMVKNpPq');
                      }

                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                    }}
                  >
                    <div>
                      { words.purchaseCards[state.language] }
                    </div>
                    <div>
                      { words.purchaseInMonacoin[state.language] }
                    </div>
                  </button>
                  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                    onClick={ () => {
                      handleClickPurchaseItem(state, dispatch, navigate);
                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                    }}
                  >
                    <div>
                      { words.purchaseCardsAndMonatokaPoints[state.language] }
                    </div>
                    <div>
                      { words.purchaseInJpy[state.language] }
                    </div>
                  </button>
                  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                    onClick={ () => {
                      handleClickItemOrderHistory(state, dispatch, navigate);
                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                    }}
                  >
                    <div>
                      { words.purchaseHistoryOfCardsAndMonatokaPoints[state.language] }
                    </div>
                    <div>
                      { words.purchaseInJpy[state.language] }
                    </div>
                  </button>
                  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                    onClick={ () => {
                      window.open('https://monatoka.booth.pm/');

                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                    }}
                  >
                    <div>
                      { words.monadomKeyCard[state.language] }
                    </div>
                  </button>
                  <button className='buttonMainColor widthMin20 heightMin4 flexColumn justifyContentCenter alignItemsCenter '
                    onClick={ () => {
                      handleClickChargePoint(state, dispatch, navigate);
                      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }); 
                    }}
                  >
                    { words.monatokaPoint[state.language] }
                  </button>
                </div>;

                const popup = { type: 'generalItems', body: body };
                dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
              }}
            >
              { words.purchaseCardsAndMonatokaPoints[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickCardRegistration(state, dispatch, navigate) }>
              { words.cardRegistration[state.language] }
            </button>
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' onClick={ () => handleClickSetting(state, dispatch, navigate) }>
              { words.setting[state.language] }
            </button>
          </div>
          {/* development */}
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
        {/* footer */}
        <Footer />
      </div>
    </div>
  );
}

// FOOTER
function Footer() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  return (
    <div className='footer'>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          window.open('https://' + process.env.REACT_APP_ABOUT_US);
        }}
      >
        {words.aboutUs[state.language]}
      </button>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          const popup = { type: 'generalItems', body: <div dangerouslySetInnerHTML={ { __html: sctHtml } } /> };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
        }}
      >
        {words.notationBasedOnTheActOnSpecifiedCommercialTransactions[state.language]}
      </button>
      {/*
        <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
          onClick={ () => {
            window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
          }}
        >
          {words.guideline[state.language]}
        </button>
      */}
    </div>
  );
}

// NOTIFICATION PERSISTENT
function NotificationPersistent() {
  const state = useGlobalStateSelector(({ state }) => state);
  let notification;

  if (state.notificationPersistent.visible) {
    notification =
    <div className='breakAll preWrap borderKOM2pxBorder padding0p5 ' >
      { state.notificationPersistent.message }
    </div>
  }


  return notification;
}

export {
  Top,
};